import { useMutation } from "@tanstack/react-query";
import CustomerReservationsClient from "../../clients/CustomerReservationsClient";

export const useSendToUVIS = () => {
  return useMutation({
    mutationFn: (uvisSubmitPayload) => {
      const { uvisRequest } = uvisSubmitPayload;
      return CustomerReservationsClient.sendToUVIS(uvisRequest);
    },
  });
};
